
import { NotFound } from "../components/404"
import GameNavigation from "../components/navigator"
export const NotFoundScreen = () => {
    return (
        <>
            <GameNavigation />
            <NotFound />
        </>
    )
}